import { render, staticRenderFns } from "./ClientInformation.vue?vue&type=template&id=3226a7e9"
import script from "./ClientInformation.vue?vue&type=script&lang=js"
export * from "./ClientInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports